import {
  Platform,
} from '@angular/cdk/platform';
import {
  Injectable,
} from '@angular/core';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  DeviceDetectionFacts,
} from './device-detection.facts';
import {
  isMobileDevice,
} from './fact-factories';

@Injectable()
export class DeviceDetectionFactsService extends FactsService<DeviceDetectionFacts> {
  public facts = {
    isMobileDevice: isMobileDevice()(this.platform)
  };

  constructor(rulesEngine: RulesEngineRunnerService, private readonly platform: Platform) {
    super(rulesEngine);
  }
}
